// extracted by mini-css-extract-plugin
export default {"contentWrapper":"newCustomer_contentWrapper__gwHLa","registerMessage":"newCustomer_registerMessage__kMbZ5"};